import React from 'react';

import { UnitListItem, UnitListItemProps } from './UnitListItem';

export interface UnitListProps {
  units: UnitListItemProps[];
}

export const UnitList: React.FC<UnitListProps> = ({ units }) => {
  return (
    <div className="oejr-lesson-list">
      {units.map((unitArgs, key) => (
        <UnitListItem key={key} {...unitArgs} />
      ))}
    </div>
  );
};
